<template>
  <div class="modal is-visible">
    <div class="modal-wrapper modal-transition">
      <div class="modal-body">
        <div class="modal-content">
          <div class="msg-text">
            <p>
              원하시는 상담 유형을 선택해 주세요.
            </p>
            <div class="support-box">
              <button
                type=""
                class="btn btn-modal modal-open"
                data-idx="0"
                @click="clickSelButton"
              >
                전문 상담
                <small>
                  장학, 학자금대출
                  <br />
                  현황 조회 등
                </small>
              </button>
              <button
                type=""
                class="btn btn-modal modal-open"
                data-idx="1"
                @click="clickSelButton"
              >
                단순 상담
                <small>
                  본인확인 없이
                  <br />
                  일정안내 등
                </small>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type=""
          class="btn btn-primary modal-toggle"
          @click="clickCloseButton"
        >
          닫기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pgmobj"],
  computed: {},
  methods: {
    clickSelButton(event) {
      this.log_debug(event);
      const evtObj = $(event.target).closest("button");
      const selIdx = parseInt(evtObj.data("idx"));

      this.$emit("close", selIdx);
    },
    clickCloseButton() {
      this.$emit("close");
    }
  }
};
</script>
